import { render, staticRenderFns } from "./settingHardware.vue?vue&type=template&id=35008f7f&scoped=true"
import script from "./settingHardware.vue?vue&type=script&lang=js"
export * from "./settingHardware.vue?vue&type=script&lang=js"
import style0 from "./settingHardware.vue?vue&type=style&index=0&id=35008f7f&prod&lang=less&scoped=true"
import style1 from "./settingHardware.vue?vue&type=style&index=1&id=35008f7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35008f7f",
  null
  
)

export default component.exports